module.exports = __webpack_public_path__ + "public/img/Menyusun Surat Bisnins Dalam Bahasa Inggris Bagi Calon Sekretaris.d8bb7b23.png";